<template>
  <div class="form-layout form-layout-2">
    <div class="row no-gutters">
      <table class="table table-striped mg-b-0">
        <thead>
          <tr>
            <th class="wd-100">Container</th>
			<th >Tipo do Container</th>
            <th >Chegada</th>
            <th >Free</th>
            <th >Deadline</th>
            <th >Carregamento</th>
            <th >Devolução</th>
            <th class="tx-right wd-150">Demurrage (R$)</th>
            <th class="tx-right wd-150">Reparo (R$)</th>
            <th class="tx-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr-inline
            v-for="item in data"
            :key="item.id"
            :row="item"
            @save="update"
            customClassesActions="container-actions"
          >
            <td-inline v-model="item.container" tdClass="td-min-width-120" :width="200" />
			<td-inline v-model="item.type" :width="200" type="v-select" tdClass="td-min-width" inputClass="select-type-document" :options="containerTypeOptions" label="label" searchable="true" searchReturnKey="label"/>
            <td-inline v-model="item.arrival" type="date" icon="fa-calendar" />
            <td-inline
              v-model="item.freetime"
              @input="calculateDeadlineAfterSetFreetimeExisting(item)"
              class="tx-medium tx-gray-900"
            />
            <td-inline v-model="item.deadline" type="date" icon="fa-calendar" />
            <td-inline
              placeholder="Data"
              v-model="item.loadingDate"
              type="date"
              icon="fa-calendar"
            />
            <td-inline
              v-model="item.devolution"
              type="date"
              icon="fa-calendar"
            />
            <td-inline v-model="item.demurrage" type="money" />
            <td-inline v-model="item.repair" type="money" />
            <template slot="actions">
              <a
                href="#"
                @click.prevent="remove(item)"
                class="btn btn-danger btn-icon rounded-circle"
              >
                <div><i class="icon ion-trash-a"></i></div>
              </a>
            </template>
          </tr-inline>
          <tr-inline
            class="new-item"
            :isNew="true"
            :row="newData"
            @save="create"
            customClassesActions="container-actions"
          >
            <td-inline placeholder="Container" tdClass="td-min-width-120" v-model="newData.container" />
			<td-inline placeholder="" v-model="newData.type" tdClass="td-min-width" inputClass="select-type-document" type="v-select" :options="containerTypeOptions" label="label" searchable="true" searchReturnKey="label"/>
            <td-inline
              placeholder="Chegada"
              v-model="newData.arrival"
              type="date"
              icon="fa-calendar"
            />
            <td-inline
              placeholder="Freetime"
              v-model="newData.freetime"
              @input="calculateDeadlineAfterSetFreetime()"
              type="number"
            />
            <td-inline
              placeholder="Deadline"
              v-model="newData.deadline"
              type="date"
              icon="fa-calendar"
            />
            <td-inline
              placeholder="Carregamento"
              v-model="newData.loadingDate"
              type="date"
              icon="fa-calendar"
            />
            <td-inline
              placeholder="Devolução"
              v-model="newData.devolution"
              type="date"
              icon="fa-calendar"
            />
            <td-inline
              placeholder="Demurrage"
              v-model="newData.demurrage"
              type="money"
            />
            <td-inline
              placeholder="Reparo"
              v-model="newData.repair"
              type="money"
            />
          </tr-inline>
        </tbody>
        <tfoot>
          <tr>
			<th colspan="2" class="tx-left">
				<span style="text-transform: none;"> O processo possui <span class="badge badge-info" style="font-size: 12px; padding: 7px 10px;">{{ data.length }}</span> conteiner(es) cadastrado(s).</span>
			</th>
            <th colspan="5" class="tx-right">Valores Totais</th>
            <th class="tx-right">
              R$ {{ totalDemurrage | numeralFormat("0,0.00") }}
            </th>
            <th class="tx-right">
              R$ {{ totalRepair | numeralFormat("0,0.00") }}
            </th>
            <th class="wd-150"></th>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment";
import config from "@/config.js";
import { mapState } from "vuex";
import inlineRow from "@/components/InlineRow.vue";
import InlineCell from "@/components/InlineCell.vue";
import CONTAINER_TYPE from '@/utils/containerType';

import Swal from "sweetalert2";

export default {
  name: "FormContainers",
  props: [],
  components: {
    "tr-inline": inlineRow,
    "td-inline": InlineCell,
  },
  data() {
    return {
      model: {},
      data: [],
      newData: {
        container: "",
		type: null,
        arrival: "",
        freetime: "",
        deadline: "",
        devolution: "",
        loadingDate: "",
        demurrage: 0,
        repair: 0,
        importProcess: null,
      },
	  containerTypeOptions: CONTAINER_TYPE,
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
      },
    };
  },
  methods: {
    freetimeIsFilled() {
      if (!this.process.freetime) {
        Swal.fire("Logística", "Freetime não informado no processo!", "error");
        return false;
      }
      return true;
    },
    calculateDeadlineAfterSetFreetime() {
      if( this.newData.arrival) {
        const dataChegada = moment(this.newData.arrival, "YYYY-MM-DD[T]hh:mm:ss");

        let dataDeadline = dataChegada;

        if (this.newData.freetime && this.newData.freetime != "undefined") {
          dataDeadline = dataChegada
            .add(parseInt(this.newData.freetime - 1), "days")
            .format("YYYY-MM-DD[T]hh:mm:ss");
        }

        this.newData.deadline = dataDeadline;
      }
    },
    calculateDeadlineAfterSetFreetimeExisting(item) {
		if (!item.arrival) {
			return;
		}
		const dataChegada = moment(item.arrival, "YYYY-MM-DD[T]hh:mm:ss");

		let dataDeadline = dataChegada;

		if (item.freetime && item.freetime != "undefined") {
			dataDeadline = dataChegada.add(parseInt(item.freetime - 1), "days").format("YYYY-MM-DD[T]hh:mm:ss");
		}

		item.deadline = dataDeadline;
    },
    updateDeadline(item, target) {
      if (item.arrival && item.freetime) {
        item.deadline = moment(item.arrival).add(
          parseInt(item.freetime) - 1,
          "day"
        );
      }
    },

    async update(value) {
      this.submit(value, "put");
    },
    async create(value) {
      if (this.freetimeIsFilled()) {
        this.submit(value, "post");
      }
    },
    async submit(value, method) {

      const requiredFields = [
        { field: 'container', message: 'Container não foi preenchido.' },
      ];

      const messageErroInputs = requiredFields.find((field) => !value[field.field])?.message;

      if (messageErroInputs) {
        Swal.fire(
          "Logística - Containers",
          messageErroInputs,
          "error"
        );
        return;
      }

      this.$store.commit("setLoading", {
        show: true,
        label: `Processo ${this.process.id}`,
        description: "Salvando dados, aguarde...",
      });

      // converte para formato correto de data
      const formatDate = (date) => date ? moment(date).format("YYYY-MM-DD[T]hh:mm:ss") : "";

      value.arrival = formatDate(value.arrival);
      value.deadline = formatDate(value.deadline);
      value.devolution = formatDate(value.devolution);
      value.loadingDate = formatDate(value.loadingDate);
	  value.type = value?.type?.value ?? null;

      this.newData.importProcess = `${config.env.API_DEFAULT.host}/importProcesses/${this.process.id}`;

      try {
        let response;
        
        if (method == "put") {
			response = await Axios.put(value._links.self.href, value);
			this.data.find((item) => item._links.self.href === value._links.self.href).type = this.containerTypeOptions.find(type => type.value === value.type);
        } else {
			response = await Axios.post(`${config.env.API_DEFAULT.host}/process/import/${this.process.id}/containers/save`, value);
			this.data = [];
			this.loadData();
        }

        this.newData = {
          container: "",
		  type: null,
          arrival: this.process.datesArrivalDate ?this.$moment(this.process.datesArrivalDate).format("Y-MM-DDTLTS") : "",
          freetime: this.process.freetime,
          deadline: this.newData.arrival ? moment(this.newData.arrival).add(parseInt(this.newData.freetime) - 1,"day") : "",
          devolution: null,
          loadingDate: null,
          demurrage: 0,
          repair: 0,
          importProcess: null,
        };

        this.$store.commit("setLoading", {
          show: false,
        });
      } catch (err) {
        this.$store.commit("setLoading", { show: false });
        let message = err?.response?.data?.message || err

        Swal.fire(
          "Logística - Containers",
          message,
          "error"
        );
      }
    },
    async remove(value) {
      try {
        this.$store.commit("setLoading", {
          show: true,
          label: `Processo ${this.process.id}`,
          description: "Processando requisição, aguarde...",
        });
        const response = await Axios.delete(value._links.self.href, value);
        const index = this.data.findIndex(
          (item) => item._links.self.href === value._links.self.href
        );
        this.data.splice(index, 1);
        this.$store.commit("setLoading", {
          show: false,
          label: "",
          description: "",
        });
      } catch (err) {
        this.$store.commit("setLoading", { show: false });
        Swal.fire("Logística", err, "error");
      }
    },

    async loadData() {
      try {
        const response = await Axios.get(
          `${config.env.API_DEFAULT.host}/importProcesses/${this.process.id}/containers/`
        );
		let data = response.data._embedded.processContainers;
		data.forEach(item => {
			item.type = this.containerTypeOptions.find(type => type.value === item.type);
		});
        this.data = data;
        this.$store.commit("setLoading", {
          show: false,
          label: "",
          description: "",
        });
      } catch (err) {
        this.$store.commit("setLoading", {
          show: false,
          label: "",
          description: "",
        });
        Swal.fire("Ops", err, "error");
      }
    },
  },
  computed: {
    ...mapState({
      process: (state) => state.ProcessStore.activeProcess,
    }),

    totalDemurrage() {
      return this.data.reduce(
        (value, item) => value + parseFloat(item.demurrage),
        0
      );
    },
    totalRepair() {
      return this.data.reduce(
        (value, item) => parseFloat(value) + parseFloat(item.repair),
        0
      );
    },
  },
  mounted() {
    this.model = {
      ...this.process,
    };

    if (
      !this.process.datesArrivalDate &&
      (this.process.step.id === 3 ||
        this.process.step.id === 4 ||
        this.process.step.id === 5)
    ) {
      Swal.fire(
        "Logística",
        "Data de Chegada não informada no processo!",
        "error"
      );
    }

    this.freetimeIsFilled();

    this.loadData();

    if (this.process.datesArrivalDate) {
      this.newData.arrival = this.$moment(this.process.datesArrivalDate).format(
        "Y-MM-DDTLTS"
      );
    }

    this.newData.freetime = this.process.freetime;

    if (this.newData.arrival) {  
      this.newData.deadline = moment(this.newData.arrival).add(
        parseInt(this.newData.freetime) - 1,
        "day"
      );
    }
  },
  watch: {
    process() {
      this.model = {
        ...this.process,
      };
      this.loadData();
    },
  },
};
</script>

<style>
.container-actions {
    display: flex;
    gap: 3px;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
}
.container-actions a {
	margin: 0 !important
}
</style>
